import * as React from "react";
import { Category } from "../types";
import useApi from "@/hooks/useApi";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "@velaro/velaro-component-lib";
import {
  PrimaryBlueButton,
  SecondaryBlueButton
} from "@velaro/velaro-component-lib";

interface Props {
  category: Category;
  onClose(): void;
  onSubmit(category: Category): void;
}

const INPUT_CLASS =
  "w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent";
const LABEL_CLASS = "block text-sm font-medium text-slate-700 mb-1";

export default function CategoryEditModal(props: Props) {
  const [saving, setSaving] = React.useState(false);
  const [category, setCategory] = React.useState<Category>(props.category);
  const api = useApi();

  const handleSubmit = React.useCallback(async () => {
    setSaving(true);
    try {
      const response = await api.admin.put("api/kb/categories", category);
      const json = await response.json();
      props.onSubmit(json);
    } catch (err) {
      console.error("Failed to update category:", err);
    } finally {
      setSaving(false);
    }
  }, [category, props]);

  return (
    <Modal show={true}>
      <ModalHeader title="Edit Category" onClose={() => props.onClose()} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <ModalBody>
          <div>
            <label htmlFor="category-name" className={LABEL_CLASS}>Name</label>
            <input
              autoFocus
              id="category-name"
              type="text"
              className={INPUT_CLASS}
              value={category.Name}
              onChange={(e) =>
                setCategory({ ...category, Name: e.currentTarget.value })
              }
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <SecondaryBlueButton
            label="Cancel"
            disabled={saving}
            onClick={() => props.onClose()}
          />
          <PrimaryBlueButton
            label={saving ? "Saving…" : "Save Category"}
            disabled={saving}
            onClick={() => handleSubmit()}
          />
        </ModalFooter>
      </form>
    </Modal>
  );
}
